import confetti from "canvas-confetti";

/** Big celebratory burst from the bottom corners. */
export function goalConfetti() {
  const fire = (originX) => {
    confetti({
      particleCount: 80,
      angle: originX < 0.5 ? 60 : 120,
      spread: 70,
      startVelocity: 55,
      origin: { x: originX, y: 0.95 },
      colors: ["#4ade80", "#22d3ee", "#a78bfa", "#FBBF24", "#a7f3d0"],
      ticks: 180,
      scalar: 1.1,
    });
  };
  fire(0.15);
  fire(0.85);
  setTimeout(() => fire(0.5), 280);
}

/** Compact burst at a specific element's centre. */
export function localBurst(el) {
  if (!el) return;
  const r = el.getBoundingClientRect();
  const x = (r.left + r.width / 2) / window.innerWidth;
  const y = (r.top + r.height / 2) / window.innerHeight;
  confetti({
    particleCount: 60,
    spread: 360,
    startVelocity: 28,
    origin: { x, y },
    colors: ["#4ade80", "#22d3ee", "#a78bfa", "#FBBF24"],
    ticks: 140,
    scalar: 0.9,
    shapes: ["circle", "square"],
  });
}

/** A short, optional UI chime using WebAudio (no asset deps). */
let _audioCtx = null;
export function chime() {
  try {
    if (!_audioCtx)
      _audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    const ctx = _audioCtx;
    const now = ctx.currentTime;
    const notes = [659.25, 783.99, 987.77]; // E5, G5, B5
    notes.forEach((freq, i) => {
      const o = ctx.createOscillator();
      const g = ctx.createGain();
      o.type = "sine";
      o.frequency.value = freq;
      g.gain.setValueAtTime(0, now + i * 0.08);
      g.gain.linearRampToValueAtTime(0.12, now + i * 0.08 + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, now + i * 0.08 + 0.35);
      o.connect(g);
      g.connect(ctx.destination);
      o.start(now + i * 0.08);
      o.stop(now + i * 0.08 + 0.4);
    });
  } catch {
    /* audio not available */
  }
}
